/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { MatchedStatementSentence } from './MatchedStatementSentence.js';
import {
    MatchedStatementSentenceFromJSON,
    MatchedStatementSentenceFromJSONTyped,
    MatchedStatementSentenceToJSON,
} from './MatchedStatementSentence.js';

/**
 * 
 * @export
 * @interface TranscriptSearchResult
 */
export interface TranscriptSearchResult {
    /**
     * 
     * @type {number}
     * @memberof TranscriptSearchResult
     */
    utteranceId?: number;
    /**
     * 
     * @type {Array<MatchedStatementSentence>}
     * @memberof TranscriptSearchResult
     */
    sentences?: Array<MatchedStatementSentence>;
    /**
     * 
     * @type {number}
     * @memberof TranscriptSearchResult
     */
    score?: number;
}

/**
 * Check if a given object implements the TranscriptSearchResult interface.
 */
export function instanceOfTranscriptSearchResult(value: object): boolean {
    return true;
}

export function TranscriptSearchResultFromJSON(json: any): TranscriptSearchResult {
    return TranscriptSearchResultFromJSONTyped(json, false);
}

export function TranscriptSearchResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): TranscriptSearchResult {
    if (json == null) {
        return json;
    }
    return {
        
        'utteranceId': json['utteranceId'] == null ? undefined : json['utteranceId'],
        'sentences': json['sentences'] == null ? undefined : ((json['sentences'] as Array<any>).map(MatchedStatementSentenceFromJSON)),
        'score': json['score'] == null ? undefined : json['score'],
    };
}

export function TranscriptSearchResultToJSON(value?: TranscriptSearchResult | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'utteranceId': value['utteranceId'],
        'sentences': value['sentences'] == null ? undefined : ((value['sentences'] as Array<any>).map(MatchedStatementSentenceToJSON)),
        'score': value['score'],
    };
}

